export const TOKEN_KEY = '@token';
export const ID_KEY = '@idkey';
export const USER_NAME = '@username';
export const TOKEN_KEY_ADMIN = '@token_admin';
export const ID_KEY_ADMIN = '@idkey_admin';
export const USER_NAME_ADMIN = '@username_admin';
